// src/pages/CompaniesPage/companyDialog/sections/SectionRechnung.jsx
import React from "react";
import { Box, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const INVOICE_CURRENCIES = ["CHF", "EUR", "USD"];

export default function SectionRechnung({ form, setForm }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr 1fr" },
                gap: 2,
            }}
        >
            <TextField
                label="Firma"
                value={form.invoice_company}
                onChange={(e) => setForm((f) => ({ ...f, invoice_company: e.target.value }))}
            />
            <TextField
                label="Zuständig"
                value={form.invoice_contact}
                onChange={(e) => setForm((f) => ({ ...f, invoice_contact: e.target.value }))}
            />
            <TextField
                label="Zusatzinfo"
                value={form.invoice_extra}
                onChange={(e) => setForm((f) => ({ ...f, invoice_extra: e.target.value }))}
            />
            <Box />

            <TextField
                label="Straße / Nr."
                value={form.invoice_street}
                onChange={(e) => setForm((f) => ({ ...f, invoice_street: e.target.value }))}
            />
            <TextField
                label="PLZ"
                value={form.invoice_zip}
                onChange={(e) => setForm((f) => ({ ...f, invoice_zip: e.target.value }))}
            />
            <TextField
                label="Ort"
                value={form.invoice_city}
                onChange={(e) => setForm((f) => ({ ...f, invoice_city: e.target.value }))}
            />
            <TextField
                label="Land"
                value={form.invoice_country}
                onChange={(e) => setForm((f) => ({ ...f, invoice_country: e.target.value }))}
            />

            <FormControl>
                <InputLabel>Währung</InputLabel>
                <Select
                    label="Währung"
                    value={form.invoice_currency || "CHF"}
                    onChange={(e) => setForm((f) => ({ ...f, invoice_currency: e.target.value }))}
                >
                    {INVOICE_CURRENCIES.map((c) => (
                        <MenuItem key={c} value={c}>
                            {c}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
